// extracted by mini-css-extract-plugin
export var messageSideLeft = "_mj-1";
export var messageSideRight = "_mj-2";
export var subscribeToBackInStockBubbleContainer = "_mj-0";